import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find-index.js";
import { getMultipleHourDataApi, getMultipleDayDataApi, getMultipleMonthDataApi, getMultipleYearDataApi } from '@/api';
import { dbDataHandle } from '@/store/function/common/index';
import { isDateAfterToday } from '@/utils/datetime';
import { METRICS, metricOption, buildDownloadRows, downloadFileName } from '@/store/function/multipleFactory/downloadRows';

import { mapState, mapActions } from 'vuex';
import { DateTime } from 'luxon';
import downloadCsv from 'download-csv';
export default {
  name: 'MultipleFactoryAnalysis',
  computed: _objectSpread(_objectSpread({}, mapState(['factoryInfo'])), {}, {
    // 只有這些會改變後端回什麼；顏色、指標開關都只影響畫圖，不用重抓
    queryKey: function queryKey() {
      return JSON.stringify([this.dateTypeActive, this.beginDate, this.endDate, this.multipleDataArr.map(function (x) {
        return x.factory;
      })]);
    },
    selectedSiteCount: function selectedSiteCount() {
      return this.multipleDataArr.filter(function (x) {
        return x.factory;
      }).length;
    },
    // 沒有真正的進度可回報（就一個 POST），至少讓使用者分得出「還在跑」和「卡死了」
    elapsedText: function elapsedText() {
      var m = Math.floor(this.elapsed / 60);
      var sec = this.elapsed % 60;
      return m ? "\u5DF2\u7D93\u904E ".concat(m, " \u5206 ").concat("0".concat(sec).slice(-2), " \u79D2") : "\u5DF2\u7D93\u904E ".concat(sec, " \u79D2");
    }
  }),
  data: function data() {
    return {
      beginDate: DateTime.local().toFormat('yyyy-MM-dd'),
      endDate: DateTime.local().toFormat('yyyy-MM-dd'),
      dateType: 'date',
      dateTypeActive: 'hour',
      // 開關只管畫圖；下載一律四個指標全給
      contextDataClass: METRICS.map(metricOption),
      dataClass: ['發電量', '日照量', '實際累積發電量'],
      countyArr: [],
      factoryArr: [],
      multipleChartDataArr: [],
      dataIssues: [],
      // 後端回報缺資料的案場，顯示在圖表上方
      loading: false,
      loadingAction: '',
      // 'chart' | 'download'，決定 spinner 掛在哪一顆按鈕
      showOverlay: false,
      // 遮罩晚 250ms 才上，快查詢不要閃一下
      elapsed: 0,
      // 這次查詢已經跑了幾秒
      showChart: false,
      // 圖表要按了才畫
      fetchedKey: '',
      // 上次抓資料的查詢條件，一樣就不重抓
      contextArr: METRICS.map(function (m) {
        return {
          value: metricOption(m),
          text: m.label
        };
      }),
      multipleDataArr: [{
        county: '高雄市',
        factory: '鳳山圳滯洪池',
        color: '#f6b73c'
      }, {
        county: 'null',
        factory: '',
        color: '#000000'
      }],
      multipleChart: {
        chart: {
          height: 350,
          backgroundColor: null
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: []
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false,
          maxHeight: 140 // 全案場時 legend 會長到看不到圖，超過就內捲
        },
        yAxis: [],
        tooltip: {
          shared: true
        },
        series: [],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
                y: 0
              }
            }
          }]
        }
      }
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions(['asyncInfo'])), {}, {
    isDateAfterToday: isDateAfterToday,
    multipleDataPush: function multipleDataPush() {
      this.multipleDataArr.push({
        county: 'null',
        factory: '',
        context: {
          values: 'pr',
          text: 'PR值'
        },
        color: '#000000'
      });
    },
    multipleDataSplice: function multipleDataSplice(idx) {
      this.multipleDataArr.splice(idx, 1);
    },
    // 黃金角取色，相鄰案場的顏色差最大，上百條線才分得出來
    siteColor: function siteColor(idx) {
      var h = idx * 137.508 % 360 / 30;
      var l = 0.45;
      var a = 0.65 * Math.min(l, 1 - l);
      var channel = function channel(n) {
        var k = (n + h) % 12;
        var v = l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1));
        return Math.round(v * 255).toString(16).padStart(2, '0');
      };
      return "#".concat(channel(0)).concat(channel(8)).concat(channel(4));
    },
    addAllSites: function addAllSites() {
      var _this = this;
      this.multipleDataArr = this.factoryArr.map(function (x, idx) {
        return {
          county: x.county,
          factory: x.factory,
          color: _this.siteColor(idx)
        };
      });
    },
    changeDateType: function changeDateType(type, format, active) {
      this.dateTypeActive = active;
      this.dateType = type;
      this.beginDate = DateTime.local().toFormat("".concat(format));
      this.endDate = DateTime.local().toFormat("".concat(format));
    },
    buildOptionArr: function buildOptionArr() {
      var _this2 = this;
      this.countyArr = [];
      this.factoryArr = this.factoryInfo.filter(function (item) {
        return !item.isDemoSite;
      }).map(function (x) {
        if (!_this2.countyArr.includes(x.informations.county)) {
          _this2.countyArr.push(x.informations.county);
        }
        return {
          county: x.informations.county,
          factory: x.factory,
          factoryId: x.factoryId
        };
      });
    },
    filterFactoryArr: function filterFactoryArr(county) {
      if (county === 'null') return this.factoryArr;
      return this.factoryArr.filter(function (x) {
        return x.county === county;
      });
    },
    clickShowChart: function clickShowChart() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this3.showChart) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", _this3.showChart = false);
              case 2:
                _this3.loadingAction = 'chart';
                _context.next = 5;
                return _this3.fetchData();
              case 5:
                _this3.showChart = _context.sent;
                _this3.loadingAction = '';
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clickDownload: function clickDownload() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.loadingAction = 'download';
                _context2.next = 3;
                return _this4.fetchData();
              case 3:
                ok = _context2.sent;
                _this4.loadingAction = '';
                if (ok) _this4.downloadAnalysis();
              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    /** 需要時才打 API。回傳有沒有資料可用 */fetchData: function fetchData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var isHour, payload, overlayDelay, tick, _res$data$data$series, _res$data, _res$data$data, _res$data$data$issues, _res$data2, _res$data2$data, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!_this5.multipleDataArr.length || !_this5.multipleDataArr.every(function (x) {
                  return Object.values(x).every(function (y) {
                    return y !== '';
                  });
                }))) {
                  _context3.next = 3;
                  break;
                }
                _this5.$swal('請正確選擇');
                return _context3.abrupt("return", false);
              case 3:
                if (!(_this5.fetchedKey === _this5.queryKey)) {
                  _context3.next = 6;
                  break;
                }
                _this5.buildChart();
                return _context3.abrupt("return", true);
              case 6:
                isHour = _this5.dateTypeActive === 'hour';
                payload = _this5.multipleDataArr.map(function (x) {
                  return _objectSpread({
                    fId: _this5.factoryInfo.find(function (y) {
                      return y.factory === x.factory;
                    }).factoryId,
                    siteName: x.factory
                  }, isHour ? {
                    todayDate: _this5.beginDate
                  } : {
                    beginDate: _this5.beginDate,
                    endDate: _this5.endDate
                  });
                });
                _this5.dataIssues = [];
                _this5.loading = true;
                _this5.elapsed = 0;
                // 按鈕上的 spinner 立刻給回饋；整片遮罩等到確定要等了才蓋，
                // 單站查詢幾百毫秒就回來，閃一下白色反而像壞掉
                overlayDelay = setTimeout(function () {
                  return _this5.showOverlay = true;
                }, 250);
                tick = setInterval(function () {
                  return _this5.elapsed += 1;
                }, 1000);
                _context3.prev = 13;
                _context3.next = 16;
                return {
                  hour: getMultipleHourDataApi,
                  date: getMultipleDayDataApi,
                  month: getMultipleMonthDataApi,
                  year: getMultipleYearDataApi
                }[_this5.dateTypeActive](payload);
              case 16:
                res = _context3.sent;
                // series 與送出的列同索引，缺資料的站是空陣列，缺什麼在 issues
                _this5.multipleChartDataArr = (_res$data$data$series = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$data = _res$data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.series) !== null && _res$data$data$series !== void 0 ? _res$data$data$series : [];
                _this5.dataIssues = (_res$data$data$issues = res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$data = _res$data2.data) === null || _res$data2$data === void 0 ? void 0 : _res$data2$data.issues) !== null && _res$data$data$issues !== void 0 ? _res$data$data$issues : [];
                _this5.buildChart(); // 只是備好 series，沒掛 highcharts 就不會真的畫
                _this5.fetchedKey = _this5.queryKey;
                return _context3.abrupt("return", true);
              case 24:
                _context3.prev = 24;
                _context3.t0 = _context3["catch"](13);
                _this5.$swal((_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.msg) || (_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message) || '資料讀取失敗');
                return _context3.abrupt("return", false);
              case 28:
                _context3.prev = 28;
                clearTimeout(overlayDelay);
                clearInterval(tick);
                _this5.showOverlay = false;
                _this5.loading = false;
                return _context3.finish(28);
              case 34:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[13, 24, 28, 34]]);
      }))();
    },
    buildChart: function buildChart() {
      var _this6 = this;
      this.multipleChart.yAxis = [];
      this.multipleChart.series = [];
      this.buildYaxis();
      this.defaultXaxis();

      // 一鍵全案場時 series 會上百條，dataLabels 跟 shared tooltip 會把瀏覽器卡死
      var heavy = this.multipleChart.series.length > 40;
      this.multipleChart.plotOptions.series.dataLabels.enabled = !heavy;
      this.multipleChart.tooltip.shared = !heavy;

      // series 的排列由 buildYaxis 決定：一個案場一段，段內依 contextDataClass 排。
      // 不要再用 z.name.split('_')[0] 反推是哪一站 —— 案場名字本身就會有底線
      // （穩懋龜山廠_FAB / _停車場 / _WWT），切出來對不上就 find 到 undefined。
      var metricCount = this.contextDataClass.length;
      this.multipleChartDataArr.forEach(function (rows, siteIdx) {
        var _this6$multipleDataAr;
        // 抓完資料後 multipleDataArr 又被改過（例如只換了指標開關就重畫），
        // 這一段的 series 已經不是當初抓的那一站，寧可不畫也不要畫錯站
        if (rows[0] && rows[0].siteName !== ((_this6$multipleDataAr = _this6.multipleDataArr[siteIdx]) === null || _this6$multipleDataAr === void 0 ? void 0 : _this6$multipleDataAr.factory)) return;
        rows.forEach(function (y) {
          var index = _this6.multipleChart.xAxis.categories.findIndex(function (q) {
            return q === y.time;
          });
          if (index < 0) return;
          _this6.contextDataClass.forEach(function (s, metricIdx) {
            // chart 顯示調整過數值
            var series = _this6.multipleChart.series[siteIdx * metricCount + metricIdx];
            series.data[index] = dbDataHandle(y[s.split('-')[1]]);
          });
        });
      });
    },
    buildYaxis: function buildYaxis() {
      var _this7 = this;
      for (var i = 0; i < this.multipleDataArr.length; i++) {
        var _loop = function _loop(j) {
          if (i === 0) {
            _this7.multipleChart.yAxis.push({
              title: {
                text: "".concat(_this7.contextDataClass[j].split('-')[0])
              },
              opposite: j % 2 === 0
            });
          }
          var obj = {
            type: 'line',
            color: _this7.multipleDataArr[i].color === '' ? '#000000' : _this7.multipleDataArr[i].color,
            name: "".concat(_this7.multipleDataArr[i].factory, "_").concat(_this7.contextDataClass[j].split('-')[0]),
            context: _this7.contextDataClass[j].split('-')[1],
            data: [],
            yAxis: _this7.multipleChart.yAxis.findIndex(function (z) {
              return z.title.text === _this7.contextDataClass[j].split('-')[0];
            })
          };
          _this7.multipleChart.series.push(obj);
        };
        for (var j = 0; j < this.contextDataClass.length; j++) {
          _loop(j);
        }
      }
    },
    defaultXaxis: function defaultXaxis() {
      var _this8 = this;
      this.multipleChart.xAxis.categories = [];
      if (this.dateTypeActive === 'hour') {
        for (var i = 0; i <= 24; i++) {
          this.multipleChart.xAxis.categories.push("0".concat(i).slice(-2) + ':00');
        }
      } else {
        var beginDate = this.beginDate;
        var endDate = this.endDate;
        var diff;
        if (this.dateTypeActive === 'date') {
          diff = DateTime.fromISO(endDate).diff(DateTime.fromISO(beginDate), 'days').days;
        }
        if (this.dateTypeActive === 'month') {
          diff = DateTime.fromISO(endDate).diff(DateTime.fromISO(beginDate), 'months').months;
        }
        if (this.dateTypeActive === 'year') {
          diff = DateTime.fromISO(endDate).diff(DateTime.fromISO(beginDate), 'years').years;
        }
        for (var _i = 0; _i <= diff; _i++) {
          if (this.dateTypeActive === 'date') {
            this.multipleChart.xAxis.categories.push(DateTime.fromISO(beginDate).plus({
              days: _i
            }).toFormat('yyyy-MM-dd'));
          }
          if (this.dateTypeActive === 'month') {
            this.multipleChart.xAxis.categories.push(DateTime.fromISO(beginDate).plus({
              months: _i
            }).toFormat('yyyy-MM'));
          }
          if (this.dateTypeActive === 'year') {
            this.multipleChart.xAxis.categories.push(DateTime.fromISO(beginDate).plus({
              years: _i
            }).toFormat('yyyy'));
          }
        }
      }

      // 補滿與 categories 等長的空格。原本兩個分支各自補，時粒度少一格
      // （categories 有 00:00~24:00 共 25 格）、日月年也少最後一格
      this.multipleChart.series.forEach(function (x) {
        x.data = _this8.multipleChart.xAxis.categories.map(function () {
          return null;
        });
      });
    },
    downloadAnalysis: function downloadAnalysis() {
      var rows = buildDownloadRows(this.multipleChartDataArr);
      if (!rows.length) return this.$swal('沒有可下載的資料');
      downloadCsv(rows, {}, downloadFileName(this.dateTypeActive, this.beginDate, this.endDate));
    }
  }),
  watch: {
    contextDataClass: function contextDataClass(oldValue, newValue) {
      if (oldValue !== newValue && this.multipleChartDataArr.length !== 0) {
        this.buildChart();
      }
    }
  },
  mounted: function mounted() {
    var _this9 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (_this9.factoryInfo.length) {
                _context4.next = 3;
                break;
              }
              _context4.next = 3;
              return _this9.asyncInfo();
            case 3:
              _this9.buildOptionArr();
            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};